import React, { useEffect, useRef } from "react";
import { ValidationError } from "@formspree/react";
import { siteInfo } from "../data/siteInfo";

export default function FormError({ errors }) {
  const errorRef = useRef(null);
  useEffect(() => {
    if (errors) errorRef.current?.focus();
  }, [errors]);
  if (!errors) return null;
  return (
    <div className="form-error" role="alert" tabIndex="-1" ref={errorRef}>
      <p>
        We couldn’t send your message. Review the fields below and try again, or{" "}
        <a href={siteInfo.phoneHref}>call {siteInfo.phone}</a>.
      </p>
      <ValidationError errors={errors} />
    </div>
  );
}
